import { Container, Button, Form, Table, Card, Row, Col } from "react-bootstrap";
import { useState, useEffect, useCallback } from 'react';
import { protectedResources, scopes } from "../authConfig";
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

export const EditCompany = (props) => {
    const [companyId, setCompanyId] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companies, setCompanies] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const { execute } = useFetchWithMsal({
        scopes: scopes.callapi
    });

    const fetchCompanies = useCallback(async () => {
        const response = await execute('GET', protectedResources.getCompanies.endpoint);
        setCompanies(response);
        setIsUpdate(false);
    }, [execute]);

    useEffect(() => {
        fetchCompanies();
        setIsUpdate(false);
    }, [fetchCompanies, isUpdate]);

    const handleRegister = async () => {
        const response = await execute('POST', protectedResources.createCompany.endpoint, {
            companyId,
            companyName,
        });
        if (response.ok) {
            setIsUpdate(true);
        }
    };

    const handleEdit = async (id) => {
        const response = await execute('PUT', protectedResources.updateCompany.endpoint, {
            companyId,
            companyName,
        });
        if (response.ok) {
            setIsUpdate(true);
        }
    };

    const handleDelete = async (id) => {
        const response = await execute("DELETE", protectedResources.deleteCompany.endpoint + "?companyId=" + id);
        if (response.ok) {
            setIsUpdate(true);
        }
    };

    return (
        <Container className="py-5">
            <Row className="mb-4">
                <Col>
                    <h1 className="fw-bold">会社管理</h1>
                </Col>
            </Row>
            
            <Row className="mb-5">
                <Col>
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-light">
                            <h5 className="mb-0">会社登録</h5>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <Form>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Form.Group controlId="formCompanyId">
                                            <Form.Label className="fw-medium">会社ID</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="会社IDを入力"
                                                value={companyId}
                                                onChange={(e) => setCompanyId(e.target.value)}
                                                className="border-secondary-subtle"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="formCompanyName">
                                            <Form.Label className="fw-medium">会社名</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="会社名を入力"
                                                value={companyName}
                                                onChange={(e) => setCompanyName(e.target.value)}
                                                className="border-secondary-subtle"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="mt-4 text-end">
                                    <Button 
                                        variant="primary" 
                                        onClick={handleRegister}
                                        className="d-inline-flex align-items-center gap-2"
                                    >
                                        <FaPlus /> 登録
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Card className="border-0 shadow-sm">
                <Card.Header className="bg-light">
                    <h5 className="mb-0">会社一覧</h5>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table hover className="align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>会社ID</th>
                                    <th>会社名</th>
                                    <th className="text-center">アクション</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(companies) && companies.map((company) => (
                                    <tr key={company.id}>
                                        <td>{company.id}</td>
                                        <td>{company.name}</td>
                                        <td>
                                            <div className="d-flex justify-content-center gap-2">
                                                <Button 
                                                    variant="outline-primary" 
                                                    size="sm"
                                                    className="d-flex align-items-center"
                                                    onClick={() => handleEdit(company.id)}
                                                >
                                                    <FaEdit />
                                                </Button>
                                                <Button 
                                                    variant="outline-danger" 
                                                    size="sm"
                                                    className="d-flex align-items-center"
                                                    onClick={() => handleDelete(company.id)}
                                                >
                                                    <FaTrash />
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default EditCompany;